export const tree = Object.freeze({
  "total": [
    "reviews",
    "social",
    "listings",
    "rankings",
    "competitors",
  ],
  "competitors": [
    "competitors.reviews",
    "competitors.responses",
    "competitors.social",
  ],
  "reviews": [
    "reviews.rating",
    "reviews.growth",
    "reviews.response",
    "reviews.sentiment",
  ],
  "listings": [
    "listings.accuracy",
    "listings.url",
    "listings.duplicates",
  ],
  "rankings": [
    "rankings.search",
    "rankings.insights",
  ],
  "rankings.search": [
    "rankings.search.web",
    "rankings.search.local",
    "rankings.search.analytics",
  ],
  "social": [
    "social.posts",
    "social.fans",
    "social.tags",
  ],
});

/**
 *
 * @param nodeName - name of the node, e.g. 'total', or 'social.posts'
 * @param depth - option max depth to traverse. Depth of one is just the nodeName, depth of 2 is nodeName and its children, etc.
 * @returns array of all the descendant nodenames up to depth, including nodeName if depth is positive,
 */
export function withDescendants(nodeName, depth = undefined) {
  if (depth !== undefined && depth < 1) {
    return []
  } else {
    return [nodeName]
      .concat(
        (tree[nodeName] || [])
          .map(desc => withDescendants(desc, depth && depth - 1))
          .reduce((a, b) => a.concat(b), [])
      )
  }
}

export const topSet = tree['total'].reduce((sum, x) => ({...sum, [x]: true}), {});

/**
 * @param scoreItems {Array.<{scorePath: String}>}
 */
export const filterTopLevelCategories = scoreItems => scoreItems.filter(x => topSet[x.scorePath]);

